import { render } from "./settings-general.windows.vue?vue&type=template&id=9f6747f2&scoped=true&ts=true"
import script from "./settings-general.windows.vue?vue&type=script&lang=ts"
export * from "./settings-general.windows.vue?vue&type=script&lang=ts"

import "./settings-general.windows.vue?vue&type=style&index=0&id=9f6747f2&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f6747f2"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QBtn,QField,QInput});
